import { useState, useEffect } from "react";

export default function IsDetective(){

    const [isMobile, setIsMobile] = useState(false);
  
    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth <= 600);
      };
      
      handleResize(); 
      window.addEventListener("resize", handleResize); 
  
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }, []);
  
    return (isMobile)
  
  }